import { SET_META_PIXELS } from '../../constants/actions';

export function setMetaPixels(data) {
  return (dispatch) => {
    dispatch({ type: SET_META_PIXELS, data });
  };
}
